import * as React from 'react';
import PropTypes from 'prop-types';

export default class PaneComponent extends React.Component {

	render() {
		return (
			<div className={'pane' + (this.props.active ? ' active' : '')} id={this.props.id}>
				{this.props.children}
			</div>
		);
	}

}

PaneComponent.propTypes = {
	active: PropTypes.bool,
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/component/tabs/pane/pane-component.js